module.exports = __webpack_public_path__ + "img/Lisa_Chris_O_9.6b798c86.jpg";